import './PillLabel.scss'

import { FC } from 'react'

const PillLabel: FC = ({ children }) => <div className="pill-label-tag">{children}</div>

export default PillLabel
